import { UPDATE_TITLE } from './constants'

export const updateTitle = (title) => ({ type: UPDATE_TITLE, title })
